<div class="wrapper">
    <div class="web-container">
        <!-- Камера 1 -->
        <div class="camera" style="width: 483px; height: 327px;">
            @if(cameras[0]?.username) {
                <span class="nickname">{{ cameras[0].username }}</span>
            }
            <div class="video-container">
                @if(cameras[0]?.vdo_ninja_link) {
                    <iframe 
                        [src]="getSafeUrl(cameras[0].vdo_ninja_link)" 
                        width="488px" 
                        height="100%" 
                        frameborder="0" 
                        allow="camera; microphone; autoplay">
                    </iframe>
                }
            </div>
        </div>

        <!-- Камера 2 -->
        <div class="camera" style="width: 483px; height: 329px;">
            @if(cameras[1]?.username) {
                <span class="nickname">{{ cameras[1].username }}</span>
            }
            <div class="video-container">
                @if(cameras[1]?.vdo_ninja_link) {
                    <iframe 
                        [src]="getSafeUrl(cameras[1].vdo_ninja_link)" 
                        width="101%" 
                        height="100%" 
                        frameborder="0" 
                        allow="camera; microphone; autoplay">
                    </iframe>
                } @else {
                    <div class="placeholder"></div>
                }
            </div>
        </div>

        <!-- Камера 3 -->
        <div class="camera" style="top: -1px;height: 330px;" >
            @if(cameras[2]?.username) {
                <span class="nickname">{{ cameras[2].username }}</span>
            }
            <div class="video-container">
                @if(cameras[2]?.vdo_ninja_link) {
                    <iframe 
                        [src]="getSafeUrl(cameras[2].vdo_ninja_link)" 
                        width="100%" 
                        height="100%" 
                        frameborder="0" 
                        allow="camera; microphone; autoplay">
                    </iframe>
                } @else {
                    <div class="placeholder"></div>
                }
            </div>
        </div>
    </div>
</div>